export const Yellow = "#e1c88d"
export const White = "white"

export const bpMobile = "600px"
